<template>
    <div>
        <apexchart dark type=bar height=400 :options="chartOptions" :series="series" />
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
    components: {
        apexchart
    },
    data: function() {
        return {
            series: [
                {
                    name: 'Realizado',
                    data: this.values.pontosReal
                },{
                    name: 'Limite Aceitável',
                    data: this.values.pontosDesejado
                }
            ],
            chartOptions: {
                colors: ['#ff5429', '#10303D'],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '50%',
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    show: true,
                    width: 1,
                    colors: ['transparent']
                },
                xaxis: {
                    title: {
                        text: 'Dias alojados',
                    },
                    categories: this.values.pontosCategorias,
                },
                yaxis: {
                    title: {
                        text: 'Valor',
                    },
                    labels: {
                        formatter: function (val) {
                            return val.toFixed(2) + ' %'
                        }
                    }
                },
                fill: {
                    opacity: 0.9
                },
                tooltip: {
                    style: {
                        fontSize: '14px',
                        fontFamily: undefined
                    },
                    y: {
                        formatter: function (val) {
                            return val + ' %'
                        }
                    },
                    x: {
                        formatter: function (val) {
                            return 'Dias alojados: ' + val
                        }
                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                    fontSize: '14px',
                    labels: {
                        useSeriesColors: false
                    },
                },
            }
        }
    },
    methods: {
        
    },
    mounted() {
        
    },
    props: {
        values: Object,
    }
}

</script>

<style>
    .apexcharts-menu.open {
        color: black;
    }
    .apexcharts-tooltip {
        background: #f3f3f3;
        color: black;
    }
</style>

